var map = {
	"./A_home": "JNB2",
	"./A_home.js": "JNB2",
	"./B_BusinessRouter": "MP/G",
	"./B_BusinessRouter.js": "MP/G",
	"./C_TradeManageRouter": "YCQL",
	"./C_TradeManageRouter.js": "YCQL",
	"./D_systemRouter": "F9Zs",
	"./D_systemRouter.js": "F9Zs",
	"./E_BasicDataRouter": "9Zng",
	"./E_BasicDataRouter.js": "9Zng"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "csuZ";


//////////////////
// WEBPACK FOOTER
// ./src/router/routers ^\.\/.*$
// module id = csuZ
// module chunks = 121